import http from '@/support/plugin/axios'

export const 

//Resgatar oferta 'apenas com solução integrada'
updateAvailableOfferRedemptionByIdAndCompanyIdAndCurrentContactId = (companyId, id) => http.patch(`companies/${companyId}/contacts/current/offers/available/${id}/redeem`)